export default __webpack_public_path__ + "static/media/02_Azure.9971a9c8.png";